import { ChakraProvider } from "@chakra-ui/react";
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/900.css";
import "./assets/fonts/fonts.css";
import "modules/timer/HackTimer";

import createCache from "@emotion/cache";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ployTheme } from "./ui/theme";
import PloyToast from "components/ds/PloyToast";

Sentry.init({
  enabled: import.meta.env.PROD,
  dsn: "https://ecf8ac01278ce89fe6efe4e6be0646f3@o4508636208168960.ingest.de.sentry.io/4508636268068944",
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      maskAttributes: [".secret"],
    }),
  ],
  // Tracing
  tracesSampleRate: 0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <ChakraProvider
    theme={ployTheme}
    // App-wide toast surface — every useToast(...) renders the Ploy card.
    toastOptions={{
      defaultOptions: {
        position: "bottom",
        duration: 4000,
        isClosable: true,
        render: ({ status, title, description, onClose, duration }) => (
          <PloyToast
            status={status}
            title={title}
            description={description}
            duration={duration}
            onClose={onClose}
          />
        ),
      },
    }}
  >
    <App />
  </ChakraProvider>,
);
